import React from 'react';
import ImageUploader from '../ImageUploader';

const Step5Images = ({ images, onImagesChange }) => {
    return (
        <div className="space-y-6">
            <div>
                <h3 className="text-lg font-semibold text-soil-900 mb-4">Property Images</h3>
                <p className="text-sm text-soil-600 mb-6">
                    Upload high-quality photos of your property. The first image will be the featured image.
                </p>
            </div>

            <ImageUploader
                images={images}
                onImagesChange={onImagesChange}
                maxFiles={20}
            />

            <div className="bg-dawn-100/40 border border-dawn-100 rounded-lg p-4">
                <h4 className="text-sm font-medium text-dawn-600 mb-2">Photography Tips</h4>
                <ul className="text-sm text-dawn-600 space-y-1 list-disc list-inside">
                    <li>Use natural lighting whenever possible</li>
                    <li>Capture multiple angles of each room</li>
                    <li>Include exterior shots and common areas</li>
                    <li>Ensure rooms are clean and well-presented</li>
                    <li>Highlight unique features and amenities</li>
                </ul>
            </div>
        </div>
    );
};

export default Step5Images;
